import { useEffect, useLayoutEffect } from 'react';

/**
 * `useLayoutEffect` in a browser, so a measurement lands before the first
 * paint, and `useEffect` in a static render, which has no tree to measure and
 * on which React warns about a layout effect.
 */
export const useBrowserLayoutEffect = typeof document === 'undefined' ? useEffect : useLayoutEffect;
